/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.columnas': 'Columnas',
'columnas.agregarColumnas': 'Create Columnas',
'columnas.modificarColumnas': 'Edit Columnas',
'columnas.eliminarColumnas': 'Delete Columnas',
'columnas.columnaId': 'Columna   Id ',
'columnas.empresaId': ' Empresa   Id ',
'columnas.descripcionColumna': ' Descripcion   Columna',
'columnas.columnas': 'Columnas',
'columnas.verColumnas': 'View Columnas',
};

